import moment from "moment";
import Filters from "../common/filter.jsx";
import BaseComponent from "../../baseComponent.js";
import DatasetService from "../../../core/services/datasetService.js";
import InternalEvent from "../../../core/constants/internalEvent.js";
import styles from "./analysis.scss";

export default class CostUtilizationAnalysis extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      activityType: 0,
      periodType: "daily",
      fromDate: moment().add(-7, "days"),
      toDate: moment(),
      datasets: []
    }
  }

  componentDidMount() {
    this.updateChart(this.state.fromDate, this.state.toDate);
  }

  handlePeriodTypeChange(periodType) {
    this.setState({
      periodType: periodType
    });

    if (this.state.toDate > moment()) {
      this.state.toDate = moment();
      this.setState({
        toDate: moment()
      });
    }

    // TODO: temporary filter for yearly based range
    if (periodType === "yearly") {
      var start = moment().startOf("year"),
        end = moment("2017-01-01").endOf("year");
      this.setState({
        fromDate: start,
        toDate: end
      });
      this.updateChart(start, end);
      return;
    }

    this.updateChart(this.state.fromDate, this.state.toDate);
  }

  handleDateFilterChange(type, date) {
    if (type === "fromDate") {
      this.setState({
        fromDate: date
      });
      this.updateChart(date, this.state.toDate);
    } else {
      this.setState({
        toDate: date
      });
      this.updateChart(this.state.fromDate, date);
    }
  }

  initTreemap(initialData) {
    const container = $(this.refs.chart);
    const width = container.width(),
      height = container.height();
    this.treemap = d3.treemap()
      .size([width, height]);
    this.$root = d3.select(`#cua-chart`);
    this.root = d3.hierarchy(initialData.data);
    this.treemapinitialized = true;
    this.renderTreeMap(initialData.min, initialData.max);
  }


  renderTreeMap(min, max) {
    var unit = max == min ? 1 : (max - min) / 10;

    this.root
      .sum(function (d) {
        return d.cost
      })
      .sort(function (a, b) {
        return b.cost - a.cost;
      });

    this.treemap(this.root);

    const lables = this.$root.selectAll('.node')
      .data(this.root.leaves())
      .enter().append("div")
      .attr("class", "node")
      .append("div")
      .attr("class", "node-label");

    lables.append("div").attr("class", "node-name");
    lables.append("div").attr("class", "node-value");

    this.$root.selectAll('.node')
      .transition()
      .duration(750)
      .attr("title", function (d) {
        this.style.color = d.data.fontColor;
        this.querySelector('.node-name').innerHTML = d.data.name;
        // this.querySelector('.node-value').innerHTML = d.data.accessCount;
        return d.data.name + "\n" + d.cost;
      })
      .style("left", function (d) {
        return d.x0 + "px";
      })
      .style("top", function (d) {
        return d.y0 + "px";
      })
      .style("width", function (d) {
        return d.x1 - d.x0 + "px";
      })
      .style("height", function (d) {
        return d.y1 - d.y0 + "px";
      })
      .style("background", function (d) {
        var index = d.data.accessCount === max ? 10 :
          Math.round((d.data.accessCount - min) / unit);
        // console.log(index);
        return getColor(10 - index);
      });

    // var container = $(this.refs.chart);
    // var width = container.width(),
    //   height = container.height();
    //
    // var unit = max == min ? 1 : (max - min) / 10;
    //
    // var treemap = d3.treemap()
    //   .tile(d3.treemapResquarify)
    //   .size([width, height])
    //   .round(true)
    //
    // if (this.node) {
    //   var tree = this.treeDiv.datum(data).selectAll(".node")
    //     .data(treemap.nodes);
    //
    //   tree.enter().append("div")
    //     .attr("class", "node");
    //
    //   tree.exit().remove();
    //
    //   tree.transition()
    //     .duration(1500)
    //     .call(position);
    //
    // } else {
    //   this.treeDiv = d3.select(this.refs.chart).append("div")
    //     .style("position", "relative")
    //     .style("width", width + "px")
    //     .style("height", height + "px");
    //
    //
    //   this.node = this.treeDiv.datum(data).selectAll(".node")
    //     .data(treemap.nodes)
    //     .enter().append("div")
    //     .attr("class", "node")
    //     .call(position);
    //
    // }
    //
    // function style(d) {
    //   if (d.children) {
    //     var index = d.children[0].accessCount === max ? 10 :
    //       Math.round((d.children[0].accessCount - min) / unit);
    //     if (isNaN(index)) {
    //       return null
    //     } else {
    //       return getColor(10 - index);
    //     }
    //   } else {
    //     return null;
    //   }
    // }
    //
    // function position() {
    //   this.style("left", function (d) {
    //     return d.x + "px";
    //   })
    //     .style("top", function (d) {
    //       return d.y + "px";
    //     })
    //     .style("width", function (d) {
    //       return Math.max(0, d.dx - 1) + "px";
    //     })
    //     .style("height", function (d) {
    //       return Math.max(0, d.dy - 1) + "px";
    //     })
    //     .style("background", style)
    //     .text(function (d) {
    //       return d.children ? null : d.name;
    //     });
    //
    // }
    //
    function getColor(value) {
      var hue = ((1 - value / 10) * 120).toString(10);
      return ["hsl(", hue, ",56.9%,45%)"].join("");
    }
  }

  updateChart(fromDate, toDate) {
    var _this = this;
    fromDate.startOf("day");
    var startTime = fromDate.toISOString().slice(0, -1);
    var endTime = toDate.toISOString().slice(0, -1);
    this.publish(InternalEvent.App.SHOW_PRELOADER);

    if (this.state.periodType === "daily") {
      DatasetService.getAccessAuditInDays(startTime, endTime, update);
    } else {
      DatasetService.getAccessAuditInMonths(startTime, endTime, update);
    }

    function update(response) {
      var preparedData = _this.prepareData(response.data, fromDate, toDate);

      if (!_this.treemapinitialized) {
        _this.initTreemap(preparedData);
      } else {
        _this.updateData(_this.root, preparedData.data);
        if (!_this.onResize) {
          _this.renderTreeMap(preparedData.min, preparedData.max)
        }
      }
      _this.publish(InternalEvent.App.HIDE_PRELOADER);
    }
  }

  updateData(root, treeMapData) {
    const node = findNode(treeMapData, root.data.name);
    if (node) {
      if(node.cost != null) {
        root.data.cost = node.cost;
        root.data.accessCount = node.accessCount;
      }
    } else {
      root.data.cost = 0;
      root.data.accessCount = 0;
    }

    root.children && root.children.forEach((c) => this.updateData(c, treeMapData));

    function findNode(data, name) {
      let node;
      if (data.name === name) {
        node = data;
      }
      data.children && data.children.forEach((c) => {
        let r = findNode(c, name);
        if (r) {
          node = r;
        }
      });
      return node;
    }
  }

  prepareData(rawData, fromDate, toDate) {  //take in raw data for a certain period of time
    var tempData = {};
    var data = {
      "name": "cost utilization analysis",
      "children": []
    };
    var min = Number.MAX_SAFE_INTEGER, max = 0;

    for (var i = 0; i < rawData.length; i++) {
      var datasetId = rawData[i].dataset;
      if (tempData.hasOwnProperty(datasetId)) {
        tempData[datasetId].accessCount += rawData[i].accessCount;
      } else {
        tempData[datasetId] = {
          name: rawData[i].name,
          cost: rawData[i].cost + 1,
          accessCount: rawData[i].accessCount
        }
      }
    }

    for (var datasetId in tempData) {
      if (tempData[datasetId].accessCount > max) {
        max = tempData[datasetId].accessCount;
      }

      if (tempData[datasetId].accessCount < min) {
        min = tempData[datasetId].accessCount;
      }
      data.children.push({
        name: tempData[datasetId].name,
        // children: [{
        //   name: tempData[datasetId].name,
          cost: tempData[datasetId].cost,
          accessCount: tempData[datasetId].accessCount
        // }]
      })
    }

    console.log(JSON.stringify(data));

    return {
      data: data,
      min: min,
      max: max
    };
  }

  render() {
    return (
      <div className="profile-cua">
        <Filters activityType={this.state.activityType}
                 periodType={this.state.periodType}
                 fromDate={this.state.fromDate}
                 toDate={this.state.toDate}
                 onPeriodTypeChange={this.handlePeriodTypeChange}
                 onDateFilterChange={this.handleDateFilterChange}/>
        <div className="cua-chart" ref="chart">
          <div id="cua-chart" style={{position: 'relative'}}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/analysis/costUtilizationAnalysis.jsx